<template lang="html">
  <div class="brand-trust">
    <div>
      <span class="notch notch--light notch--lg notch--bm"></span>
      <h2>brands that trust us</h2>
    </div>
    <ul class="brand-grid">
      <li v-for="brand in brands" class="brand-logo">
        <img :src="brand.logo" :alt="brand.alt">
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'brand-trust',
    data () {
      return {
        brands: [
          {
            logo: '../static/svg/client-logos/GE.svg',
            alt: 'Logo 1'
          },
          {
            logo: '../static/svg/client-logos/Trane.svg',
            alt: 'Logo 2'
          },
          {
            logo: '../static/svg/client-logos/NASA.svg',
            alt: 'Logo 3'
          },
          {
            logo: '../static/svg/client-logos/Embraer.svg',
            alt: 'Logo 4'
          },
          {
            logo: '../static/svg/client-logos/IntuitiveSurgical.svg',
            alt: 'Logo 5'
          },
          {
            logo: '../static/svg/client-logos/Covidien.svg',
            alt: 'Logo 6'
          },
          {
            logo: '../static/svg/client-logos/IngersollRand.svg',
            alt: 'Logo 7'
          },
          {
            logo: '../static/svg/client-logos/Omnicell.svg',
            alt: 'Logo 8'
          },
          {
            logo: '../static/svg/client-logos/IndianMotorcycle.svg',
            alt: 'Logo 9'
          },
          {
            logo: '../static/svg/client-logos/Medtronic.svg',
            alt: 'Logo 10'
          }
        ]
      }
    }
  }
</script>

<style lang='scss'>
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';

  .brand-trust {
    padding-top: 11rem;
    padding-bottom: 2rem;
    background: url('/static/images/truck-diagram-2x.png') no-repeat top center,
    linear-gradient(to right, $light-blue, $dark-blue);
    background-size: contain;
    > div {
      margin: 0 auto;
      max-width: 61.250rem;
      text-align: center;
      h2 {
        margin: 0;
        font-family: $montserrat;
        font-size: 2.750rem;
        font-weight: 700;
        text-transform: uppercase;
        color: $white;
      }
    }
  }

  .brand-grid {
    list-style-type: none;
    margin-top: 2.500rem;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(2, minmax(20vw, 1fr));
    grid-auto-rows: minmax(auto, 20vw);
    grid-gap: 0.063rem;
    @include breakpoint($sm) {
      grid-template-columns: repeat(5, minmax(20vw, 1fr));
    }
  }

  .brand-logo {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 2rem;
    background-color: $white;
    // @include breakpoint(max-width $sm) {
    //     &:nth-child(n+5) {
    //       display: none;
    //     }
    //   }
    img {
      width: 100%;
      height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BrandTrust.vue